import React, { useEffect, useState } from "react";
import { OrdersToolbarProps } from "../../../../shared/services/interface";
import SearchField from "./SearchField";
import ImportButton from "./ImportButton";
import ExportSelect from "./ExportSelect";
import FilterSelect from "./FieldSelect";
import CustomDropdownSelect from "src/business-types/grocery/components/DropdownSelect";

export const STATUS_OPTIONS = ["Confirm", "In-process", "Waiting for delivery", "Delivered", "Cancelled"];

const OrdersToolbar: React.FC<OrdersToolbarProps> = ({
  searchTerm,
  handleSearch,
  inputRef,
  handleImport,
  handleExport,
  orders,
  selectedDate,
  selectedDate2,
  selectedOption,
  handleFilterChange,
  statusFilter = "",
  onStatusFilterChange = () => {},
}) => {
  const [localStatusFilter, setLocalStatusFilter] = useState(statusFilter);

  useEffect(() => {
    setLocalStatusFilter(statusFilter);
  }, [statusFilter]);

  const handleStatusChange = (value: string) => {
    setLocalStatusFilter(value);
    onStatusFilterChange(value);
  };

  return (
    <div className="w-full px-4 sm:px-5 py-4 mt-1 -mb-3">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-4 items-end w-full">
        {/* 1. Date Filter */}
        <div className="w-full min-w-0">
          <FilterSelect selectedOption={selectedOption} handleFilterChange={handleFilterChange} />
        </div>

        {/* 2. Status Filter */}
        <div className="w-full min-w-0">
          <CustomDropdownSelect
            title="Status Filter"
            titleClassName="font-bold"
            name="statusSelected"
            value={localStatusFilter}
            titleofSelect="All Status"
            options={STATUS_OPTIONS.map((o) => ({ _id: o, CategoryName: o }))}
            onChange={handleStatusChange}
            className="!mb-0 w-full"
          />
        </div>

        {/* 3. Export Select */}
        <div className="w-full min-w-0">
          <ExportSelect orders={orders} selectedDate={selectedDate} selectedDate2={selectedDate2} handleExport={handleExport} />
        </div>

        {/* 4 + 5. Import + Search */}
        <div className="col-span-2 flex items-end gap-4 w-full min-w-0">
          {/* Import */}
          <div className="w-24 shrink-0">
            <ImportButton inputRef={inputRef} handleImport={handleImport} />
          </div>

          {/* Search */}
          <div className="flex-1 min-w-0">
            <SearchField searchTerm={searchTerm} handleSearch={handleSearch} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrdersToolbar;
